import $ from 'jquery';
import {br2nl, is_function, is_string} from '../../Helpers/js';

//======================================== //
// LamaPoll Main Class                     //
//======================================== //

const LP = (window['LP'] ??= {
  mainDiv: null,

  unbusyMode: false,
  reportMode: true, // send js error notifications
  isDispatching: false,

  // ----------------
  // Initialisation
  // ----------------

  initLanguages: function (root, onChange) {
    $('.lp-multitext-languages', root).change(function () {
      if (is_function(onChange)) {
        onChange($(this).val());
      }
    });
  },

  initButtons: function (root) {
    window['UI'].setupButtons($('.lp-button', root));
  },

  initProgressBars: function (root) {
    window['UI'].setupProgressBars($('.lp-progressbar-bar', root));
  },

  initRespondend: function () {
    document.onkeypress = LP.Poll.supressEnterKey;

    LP.Poll.initResponse();

    if ($('#lp-print-mode').val() == '1') {
      LP.initPrintview();
    }
  },

  initPrintview: function () {
    const print = () => {
      const survey = document.getElementById('poll');
      if (survey) {
        // we delay printing here, to give the browser time to render js and css.
        // if we execute window.print() right away, the printed page will randomly
        // have wrong styles, missing elements and texts.
        setTimeout(() => window.print(), 500);
        clearInterval(interval);
      }
    };
    const interval = setInterval(() => print(), 250);
  },

  isBusy: function () {
    return $('body').hasClass('busy_cursor');
  },

  clickLink: function (elm) {
    elm = $(elm);
    if (elm.is('[disabled]')) {
      return false;
    }

    var url = elm.attr('url');
    var params = elm.attr('url_params') || '';
    var target = elm.attr('target');

    window['Browser'].redirectPost(url, params, target);

    return false;
  },

  submitForm: function (form) {
    var oldForm = $(form);

    // Create form
    var newId = Math.random().toString(36).substring(7);
    var newForm = '<form id="' + newId + '" action="' + oldForm.attr('action') + '" method="' + oldForm.attr('method') + '">';

    // Copy elements
    $('input', oldForm).each(function (index, obj) {
      var input = $(obj);
      if (input.attr('type') != 'hidden' && !input.is(':visible')) {
        return;
      }
      if (input.attr('type') == 'radio' && !input.is(':checked')) {
        return;
      }
      if (input.attr('type') == 'checkbox' && !input.is(':checked')) {
        return;
      }
      newForm += '<input type="hidden" name="' + input.attr('name') + '" value="' + input.val() + '" />';
    });
    $('select', oldForm).each(function (index, obj) {
      var select = $(obj);
      newForm += '<input type="hidden" name="' + select.attr('name') + '" value="' + select.val() + '" />';
    });
    $('textarea', oldForm).each(function (index, obj) {
      var text = $(obj);
      newForm += '<textarea name="' + text.attr('name') + '">' + text.html() + '</textarea>';
    });
    newForm += '</form>';

    // Add to document
    $(newForm).appendTo($(document.body));
    newForm = $('#' + newId);

    // Submit new form
    newForm.submit();

    // Remove nerw form
    newForm.remove();
  },

  // ----------------
  // Page Functions
  // ----------------
  currentPage: null,

  setPage: function (page) {
    LP.currentPage = page;
  },

  initPage: function (json) {
    if (LP.currentPage && is_function(LP.currentPage.init)) {
      LP.currentPage.init(json);
    }
    return true;
  },

  reloadPage: function (json) {
    if (LP.currentPage && is_function(LP.currentPage.reload)) {
      LP.currentPage.reload(json);
    }
    return true;
  },

  unloadPage: function () {
    if (LP.currentPage && is_function(LP.currentPage.onUnload) && !LP.currentPage.onUnload()) {
      return false;
    }
    return true;
  },

  refreshPage: function () {
    if (LP.currentPage && is_function(LP.currentPage.refreshPageWithLang)) {
      LP.currentPage.refreshPageWithLang();
    }
  },

  // ----------------
  // Helper Functions
  // ----------------

  confirm: function (item) {
    var text = '';
    if (is_string(item)) {
      text = item;
    } else if ($('.confirmation', item).length > 0) {
      text = $('.confirmation', item).html();
    } else {
      text = item.html();
    }

    return window['Browser'].confirm(br2nl(text));
  },

  prompt: function (item, defValue) {
    var text = '';
    if (is_string(item)) {
      text = item;
    } else if ($('.confirmation', item).length > 0) {
      text = $('.confirmation', item).html();
    } else {
      text = item.html();
    }

    return window['Browser'].prompt(br2nl(text), defValue);
  },

  getLanguage: function () {
    return document.getElementsByTagName('html')[0].lang || 'en';
  },
});
export default LP;
